import styled from '@emotion/styled';
import { useLayoutHeaderContext } from '../../../modules/LayoutHeaderContext';
import Icon from '../../../shared/designSystem/components/Icon';
import { resetButton } from '../../../styles/reset';

type Props = {
  onClick: () => void;
  className?: string;
};

export default function SideBarButton({ onClick, className: className }: Props) {
  const { theme } = useLayoutHeaderContext();
  const isTransparent = theme !== 'white';
  const iconName = isTransparent ? 'ic_hamburger_md_White' : 'ic_hamburger_md_gray_600';

  return (
    <Container type="button" onClick={onClick} className={className}>
      <HamburgerIcon name={iconName} />
    </Container>
  );
}

const Container = styled.button`
  ${resetButton};

  padding: 12px 16px;
`;
const HamburgerIcon = styled(Icon)`
  width: 24px;
  height: 24px;
`;
